import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import CompanyManagement from './CompanyManagement';

const CompanyManagementIndex = memo(() => {
    const login = useSelector((state) => state.config.login);
    return login ? <CompanyManagement /> : null;
});

export default CompanyManagementIndex;
